import React from 'react';
import { MotifCheckbox } from '@ey-xd/motif-react';

export default (props) => {
  const value = props.data ? props.data[props.colDef.field] : null;
  const reportPeriodID = props.data ? props.data.reportPeriodID : null;
  return (
    <span>
      <MotifCheckbox
        type="checkbox"
        name="cell-checkbox"
        id={`ag-cell-checkbox-${reportPeriodID}`}
        checked={value}
        tabindex="-1"
        aria-label="Press Space to toggle row selection"
        onClick={() => props.onCellCheckboxChange(reportPeriodID, props.node)}
      ></MotifCheckbox>
    </span>
  );
};
